<template>
    <div class="flex items-center gap-2">
        <template v-for="(locale, index) in locales">
            <button
                type="button"
                :class="{ '!opacity-100': currentLocale === locale}"
                class="opacity-20 uppercase transition"
                @click="changeLocale(locale)"
            >
                {{ locale }}
            </button>
            <span v-if="index !== (locales.length-1)"> / </span>
        </template>
    </div>
</template>
<script>
import {mapActions, mapState} from "vuex";

export default {
    name: 'MoleculeLocaleSelector',
    computed: {
        locales() {
            return [
              'fr',
              'en'
            ];
        },
        ...mapState('localization', [
            'currentLocale'
        ]),
    },
    methods: {
        ...mapActions('localization', [
            'changeLocale',
        ]),
    },
}
</script>
